import { signInWithEmailAndPassword, signOut, UserCredential } from "firebase/auth";
import { auth } from "src/firebase";
import {
  removeLoggedInKey,
  removeLoggedInRoleKey,
  setCookieWithKey,
  setLoggedInKey,
  setLoggedInRoleKey,
} from "src/utils/browserStorage.util";
import { User } from "src/entities/user.entity";
import { userRepository } from "src/repositories/user.repository";
import { Timestamp } from "firebase/firestore";
export type ILogin = {
  email: string,
  password: string,
}
class AuthenticationService {

  private async authLogin(data: ILogin): Promise<{ credential: UserCredential } | null> {
    try {
      const credential = await signInWithEmailAndPassword(
        auth,
        data.email.trim(),
        data.password
      );
      return { credential }
    } catch (e) {
      console.error("Authentication error:", e);
      return null
    }
  }
  async login(data: ILogin) {
      const authRes = await this.authLogin(data)
      console.log("authRes", authRes)
      if (!authRes) {
        throw new Error("INVALID_CREDENTIALS")
      }
      
      // Fetch user and infer role from Firestore roles[] (ADMIN wins)
      const user = await userRepository.findByEmail(data.email)
      if (!user) {
        // Firebase auth succeeded but we don't have a profile in Firestore
        throw new Error("PROFILE_NOT_FOUND")
      }

      const roles = user.roles ?? []
      const inferredRole: "admin" | "employee" | null =
        roles.includes("ADMIN" as any) ? "admin" :
        roles.includes("EMPLOYEE" as any) ? "employee" :
        null

      // Only allow admins & employees to login
      if (!inferredRole) {
        throw new Error("NOT_AUTHORIZED")
      }

      // Update last login and set session cookies
      userRepository.update(user.id, { lastLogin: Timestamp.now() })
      this.setSessionCookies(user, inferredRole)
      
      return user
  }
   private setSessionCookies(user:User,userRole:"admin" | "employee"){
    const userKey=userRole==="admin" ? "current-admin" : "current-employee"
    setCookieWithKey(userKey, user);
    setLoggedInKey("true")
    setLoggedInRoleKey(userRole);
  
  
  
  }
  async logout(): Promise<
    { data: undefined } | { error: boolean }
  > {
    try {
      await signOut(auth);
      removeLoggedInKey();
      removeLoggedInRoleKey();
      return { data: undefined };
    } catch (error) {
      return { error: true };
    }
  }
}

export const authenticationService=new AuthenticationService()